import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { WidgetLayout } from '../../../../lib/widget-layout'
import Text from '../../../../ui/Text'
import { Table, TableBody, TableBodyCell, TableHeader, TableHeaderCell, TableRow } from '../../../../lib/table'
import { MeasurementDeviceExtendedGetModel } from '../../../redux/api/web-api'
import useText from '../../../hooks/useText'

export type MeasurementDevicePropertiesProps = {
    devices?: MeasurementDeviceExtendedGetModel[]
    className?: ClassName
    style?: React.CSSProperties
}

export function MeasurementDeviceProperties({
    devices,
    className,
    style,
}: MeasurementDevicePropertiesProps): React.ReactElement {
    const text = useText()
    return (
        <WidgetLayout title={text('lblMeasurementDeviceProperties')} className={cn(className)} style={style}>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>
                            <Text code="lblName" />
                        </TableHeaderCell>
                        <TableHeaderCell>
                            <Text code="lblDescription" />
                        </TableHeaderCell>
                        <TableHeaderCell>
                            <Text code="lblActive" />
                        </TableHeaderCell>
                        <TableHeaderCell>
                            <Text code="lblMaxCurrent" />
                        </TableHeaderCell>
                        <TableHeaderCell>
                            <Text code="lblStatus" />
                        </TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {devices?.map((device) => (
                        <TableRow key={Math.random()}>
                            <TableBodyCell data-testid="deviceName">{device.name}</TableBodyCell>
                            <TableBodyCell data-testid="deviceDescription">{device.description}</TableBodyCell>
                            <TableBodyCell>{device.active?.toString() ?? ''}</TableBodyCell>
                            <TableBodyCell>
                                {device.loadBalancerGroupSupplyMaxCurrent || '---'} <Text code="lblAmpereShort" />
                            </TableBodyCell>
                            <TableBodyCell>{device.status}</TableBodyCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </WidgetLayout>
    )
}
